export default {
	PERSON_ATTRIBUTES: 'Person attributes',
	USERS: 'Users',
	JUICER_OPERATIONAL_RESPONSIBILITIES: 'Operational responsibilities',
};
